import React from "react"
import ReactNative from "react-native"
import Device from "app/lib/Device"

import { connect } from "react-redux"
import * as Animatable from "react-native-animatable"
import FS from "app/components/FS"
import LoadingOverlay from "app/components/LoadingOverlay"
import Guide from "app/views/MyChallenge/components/Guide"

import ChallengeAcceptButton from "./ChallengeAcceptButton"
import ChallengeDifficultyDetails from "./ChallengeDifficultyDetails"

import { colors } from "app/lib/styles"

const { Platform, StatusBar, View, StyleSheet } = ReactNative

class ChallengeLevelSelector extends React.Component {
  static defaultProps = {
    maxDifficultyLevelAchieved: 0,
  }

  constructor(props) {
    super(props)

    var startLevel = 1
    if (this.props.maxDifficultyLevelAchieved) {
      startLevel = this.props.maxDifficultyLevelAchieved
    }
    if (this.props.difficultyLevel) {
      startLevel = this.props.difficultyLevel
    }
    this.state = {
      activeDifficultyLevel: startLevel,
      guideBookActive: false,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.difficultyLevel !== this.props.difficultyLevel) {
      this.activateDifficulty(nextProps.difficultyLevel)
    }
  }

  onLevelsListLayout = e => {
    var challenge = this.props.challenge
    var difficulties = challenge.challenge_difficulties.sort(
      (a, b) => a.difficulty_level - b.difficulty_level
    )
    var idx = 0
    for (var i = 0; i < difficulties.length; i++) {
      var diff = difficulties[i]
      if (diff.difficulty_level === this.state.activeDifficultyLevel) {
        idx = i
        break
      }
    }

    var width = e.nativeEvent.layout.width
    var itemWidth = width / difficulties.length
    if (idx * itemWidth > Device.width) {
      if (this._levelsListScroller) {
        this._levelsListScroller.scrollTo({ x: (idx - 1) * itemWidth, animated: true })
      }
    }
  }

  handleBackButton = () => {
    if (this.props.navigator) {
      this.props.navigator.pop()
    } else if (this.props.onBack) {
      this.props.onBack()
    }
  }

  toggleGuide = () => {
    if (this.state.guideBookActive) {
      this._guideWrap.slideOutDown(300).then(() => {
        this.setState({ guideBookActive: false })
      })
    } else {
      this.setState({ guideBookActive: true })
    }
  }

  acceptChallenge = () => {
    if (this.props.onAccept) {
      var activeLevel = this.props.challenge.challenge_difficulties.filter(
        diff => diff.difficulty_level === this.state.activeDifficultyLevel
      )[0]
      this.props.onAccept(this.props.challenge, activeLevel)
    }
  }

  activateDifficulty = difficultyLevel => {
    this.setState({
      activeDifficultyLevel: difficultyLevel,
    })
  }

  renderGuide() {
    if (this.state.guideBookActive) {
      return (
        <Animatable.View
          style={styles.guideWrap}
          animation="slideInUp"
          duration={400}
          ref={c => (this._guideWrap = c)}
        >
          <View style={styles.guideHeader}>
            <FS.Touchable onPress={this.toggleGuide}>
              <FS.Icon
                name={this.props.onBack ? "x-square" : "left-arrow"}
                style={styles.guideCloseIcon}
              />
            </FS.Touchable>
          </View>
          <Guide {...this.props} challenge={this.props.challenge} style={styles.guide} />
        </Animatable.View>
      )
    }
  }

  render() {
    var challenge = this.props.challenge
    var activeLevel = challenge.challenge_difficulties.filter(
      diff => diff.difficulty_level === this.state.activeDifficultyLevel
    )[0]
    var difficulties = challenge.challenge_difficulties.sort(
      (a, b) => a.difficulty_level - b.difficulty_level
    )

    return (
      <FS.ScrollView style={[styles.container, this.props.style]}>
        <StatusBar hidden />
        <View style={styles.header}>
          <FS.Touchable onPress={this.handleBackButton}>
            <FS.Icon
              name={this.props.onBack ? "x-square" : "left-arrow"}
              style={styles.backButton}
            />
          </FS.Touchable>
        </View>

        <FS.Text allowFontScaling={true} style={styles.challengeName} numberOfLines={2}>
          {challenge.name}
        </FS.Text>

        <FS.Text allowFontScaling={true} style={styles.challengeDescription}>
          {challenge.description}
        </FS.Text>

        {challenge.guide_url ? (
          <FS.Touchable onPress={this.toggleGuide} style={styles.guideLink}>
            <FS.Text style={styles.guideLinkText}>Preview Guidebook</FS.Text>
          </FS.Touchable>
        ) : null}

        <View>
          <FS.ScrollView
            horizontal={true}
            ref={c => (this._levelsListScroller = c)}
            style={styles.levelsListWrap}
            contentContainerStyle={styles.levelsListWrapContent}
          >
            <View style={styles.levelsList} onLayout={this.onLevelsListLayout}>
              {difficulties.map(diff => {
                var active = activeLevel.id === diff.id
                if (active || !this.props.activeLevelOnly) {
                  var maxAchieved = Math.max(
                    this.props.maxDifficultyLevelAchieved || 0,
                    1
                  )
                  var enabled =
                    this.props.activeLevelOnly || maxAchieved >= diff.difficulty_level - 1
                  var Component = enabled ? FS.Touchable : View
                  return (
                    <Component
                      key={diff.id}
                      onPress={() => this.activateDifficulty(diff.difficulty_level)}
                    >
                      <View style={[styles.level, active ? styles.levelActive : null]}>
                        <FS.Icon
                          name={enabled ? "checkmark" : "lock-filled"}
                          style={[styles.levelIcon]}
                        />
                        <FS.Text style={[styles.levelName]}>{diff.displayName}</FS.Text>
                        {active ? (
                          <View
                            style={[
                              styles.levelActiveNotch,
                              { left: 50 + activeLevel.displayName.length },
                            ]}
                          />
                        ) : null}
                      </View>
                    </Component>
                  )
                }
              })}
            </View>
          </FS.ScrollView>
        </View>

        <View style={styles.levelDetail}>
          <FS.Text style={styles.levelDetailName} allowFontScaling={true}>
            Details
          </FS.Text>

          <ChallengeDifficultyDetails challengeDifficultyId={activeLevel.id} />

          {!this.props.informationOnly ? (
            <ChallengeAcceptButton onPress={this.acceptChallenge} />
          ) : null}

          {challenge.disclaimer ? (
            <FS.Text allowFontScaling={true} style={styles.challengeDisclaimer}>
              {challenge.disclaimer}
            </FS.Text>
          ) : null}
        </View>
        <LoadingOverlay isLoading={this.props.subscribingToChallenge} />
        {this.renderGuide()}
      </FS.ScrollView>
    )
  }
}

function mapStateToProps(state) {
  return Object.assign({}, state.challenges, {})
}

export default connect(mapStateToProps)(ChallengeLevelSelector)

var styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.challengeOrange,
  },
  header: {
    flexDirection: "row",
    alignItems: "center",
  },
  backButton: {
    color: colors.white,
    fontSize: 18,
    paddingLeft: 20,
    paddingRight: 14,
    paddingVertical: 12,
    marginLeft: 0,
  },
  challengeName: {
    color: colors.white,
    fontSize: 22,
    letterSpacing: -0.5,
    fontWeight: "300",
    paddingHorizontal: 30,
    textAlign: "center",
  },
  challengeDescription: {
    color: colors.white,
    textAlign: "center",
    fontSize: 16,
    letterSpacing: -0.3,
    lineHeight: 18,
    marginTop: 5,
    marginBottom: 15,
    paddingHorizontal: 20,
  },
  challengeDisclaimer: {
    color: colors.gray,
    textAlign: "center",
    fontSize: 11,
    fontWeight: "300",
    letterSpacing: -0.1,
    lineHeight: 13,
    marginTop: 25,
    marginBottom: 15,
    paddingHorizontal: 1,
  },
  levelsListWrap: {
    flex: Platform.OS !== "web" ? 0 : null,
  },
  levelsListWrapContent: {
    flex: Platform.OS !== "web" ? 0 : null,
    flexDirection: "row",
  },
  levelsList: {
    flex: Platform.OS !== "web" ? 0 : null,
    flexDirection: "row",
    paddingVertical: 10,
  },
  level: {
    position: "relative",
    justifyContent: "center",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingBottom: 20,
    flexDirection: "row",
    opacity: 0.6,
  },
  levelActive: {
    opacity: 1,
  },
  levelIcon: {
    color: colors.white,
    fontSize: 12,
    marginRight: 8,
  },
  levelName: {
    color: colors.white,
    fontSize: 16,
    fontWeight: "500",
    letterSpacing: -0.4,
  },
  levelActiveNotch: {
    backgroundColor: colors.white,
    width: 10,
    height: 10,
    transform: [{ rotate: "45deg" }],
    position: "absolute",
    bottom: -15,
    left: 40,
  },
  levelDetail: {
    backgroundColor: colors.white,
    flex: 1,
    padding: 22,
  },
  levelDetailName: {
    textAlign: "center",
    color: colors.challengeOrange,
    fontSize: 16,
    lineHeight: 22,
    letterSpacing: -0.4,
    marginBottom: 19,
  },
  guideLinkText: {
    textAlign: "center",
    color: colors.white,
    fontWeight: "800",
    padding: 20,
    marginTop: -10,
    marginBottom: -5,
  },
  guideWrap: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    height: Device.height,
  },
  guideHeader: {
    backgroundColor: colors.white,
  },
  guideCloseIcon: {
    paddingHorizontal: 20,
    paddingVertical: 12,
    fontSize: 18,
  },
  guide: {
    flex: 1,
  },
})
